import React from 'react';
import ReportingFinancesSettlementsPage from '../components/ReportingFinancesSettlementsPage';

const ReportingFinancesSettlementsApp = (props) => (
  <ReportingFinancesSettlementsPage {...props} />
);

export default ReportingFinancesSettlementsApp;
